import React from "react";

const HeaderLabel = ({label}) => {
    return ( 
        <span className="header-label">{label}</span>
     );
}
 
export default HeaderLabel;